import React, {useState, useEffect} from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './scaninfowindowpopout.css';
import {CSSTransition} from 'react-transition-group';
import {colorFunctions} from "../../../constants/colors";
import OmniScanLocalInfoDrawer from "../../../components/local/OmniScanLocalInfoDrawer";

export default function FacilityDetails({displayFlag, closeFunction}){
	
	useEffect(() => {
		
	}, [displayFlag]);
	
	const arrowHolder = {
		display:"flex",
		width:"40px",
		height:"40px",
		backgroundColor:"white",
		alignItems:'center',
		justifyContent:"space-around",
		borderRadius:"20px",
		boxShadow:'0 3px 6px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.08)',
		zIndex:"1000"
	};
	
	const popOutContainer = {
		display:"flex",
		width:"100%",
		alignItems:"center",
		
	};
	
	const popOutContent = {
		display:"flex",
		width:"calc(100% + 0px)",
		flexDirection:"column",
		backgroundColor:"white",
		height:"calc(100vh - 60px)",
		borderRight:"1px solid lightgrey",
		marginLeft:"-20px",
		borderTopLeftRadius:'13px',
		borderBottomLeftRadius:'13px'
	};
	
	const handleArrowClick = () => {
 		closeFunction();
 	};
 	
 	const iconStyle = {
		display:"flex",
		width:"22px",
		height:"22px",
		color:"darkgrey",
		cursor:'pointer'
	};
	
	return (
		<CSSTransition
				    in={displayFlag}
				    classNames="scaninfowindowpopout"
				    timeout={1000}
				    appear={false}
				>
				<div className="scaninfowindowpopout">
					<div style={popOutContainer}>
						<div style={arrowHolder}>
							<FontAwesomeIcon icon="angle-right" style={iconStyle} onClick={handleArrowClick}/>
						</div>
						<div style={popOutContent}>
							<OmniScanLocalInfoDrawer/>
						</div>
					</div>
				</div>
			</CSSTransition>
	);
}